/**
 * Generate random 6-digit numeric room code
 * @returns {string} 6-digit room code (e.g., "123456")
 */
export function generateRoomCode() {
  const digits = '0123456789';
  let code = '';
  for (let i = 0; i < 6; i++) {
    code += digits.charAt(Math.floor(Math.random() * digits.length));
  }
  return code;
}
